import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import ToastComponent from '../../components/toast';
import { AllowedCompanyMappingService } from '../../services/wealthlane-identity-services';

const usePostCompanyMapping = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  closeModal: () => void,
  modalStatus: string
): UseMutationResult => {
  const queryClient = useQueryClient();

  return useMutation(
    async (payload) => {
      return await handleRequest(
        AllowedCompanyMappingService.postApiIdentityApiAppAllowedCompanyMapping(payload as any)
      );
    },

    {
      onSuccess: async () => {
        toast.success(
          <ToastComponent label='Success' message={`Company Mapping ${modalStatus}ed.`} />
        );
        await queryClient.invalidateQueries('getAllAllowedCompanyMappings');
        closeModal();
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default usePostCompanyMapping;
